// extracted by mini-css-extract-plugin
export default {"dotDropdown":"dropdown_dotDropdown__eqm67","nonPlatformUser":"dropdown_nonPlatformUser__vCQ1v","mentorList":"dropdown_mentorList__Y0kG6"};